// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__EqaZW","modal-container":"Modal_modal-container__YNG1-","header":"Modal_header__znMi4","title":"Modal_title__p-V3F"};